import React, { useEffect, useState, useRef } from "react";
import s from './listeningPartb.module.css';
import {getData, postData} from '../middleware/apiMiddleware';
import { useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import {MyInput} from '../components/Utilities/MyInput';

import MyTooltip from '../components/Utilities/MyTooltip';
import MyComponentLoading from '../components/Utilities/MyComponentLoading';
import {unsecuredCopyToClipboard} from '../middleware/clipboardService';

import {GreenButton, BlueButton, RedButton} from '../components/MyButton';
import {
  useSearchParams
} from "react-router-dom";

import {modifiedDate} from '../middleware/dateControl';

export default function ListeningPartB() {
	const navigate = useNavigate();
	
	let params = useParams();
  let id = params.id;
	
	const [fetchCompleted, setFetchCompleted] = useState(false);
	const [basic, setBasic] = useState(null);
	const [aiHistory, setAiHistory] = useState([]);
	
	const searchByResultId = () => {
		getData('userListeningApi/getByResultId?id=' + id, navigate)
			.then(res => {
				
				setBasic(res.data.result);
				setAiHistory(res.data.resultHistory);
				setFetchCompleted(true);
			}
		);
	}
	
	useEffect(() => {
		searchByResultId();
	}, []);
	
	if (!fetchCompleted) {
		return (<MyComponentLoading />)
	}
	
	const MyTextarea = ({title, value }) => {
		const [isFocused, setIsFocused] = useState(false);

		return (
				<div className={s.generalTextarea}>
						<div className={s.textareaTitle}>{title}</div>
						 <textarea className={(isFocused) ? s.customTextareaFocused : s.customTextarea}
								value={value}
								readOnly
								onFocus={() => {
									unsecuredCopyToClipboard(value);
								setIsFocused(true)}}
								onBlur={() => setIsFocused(false)}
						/>
				</div>
		);
	};
	
	return (<div>
		<div className={s.partHolder}>
			<div style={{display:"flex", gap:"10px", margin:"10px", alignItems:"center"}}>	
				<div>Result Id</div>
				<div className={s.generalTitle}>{basic.id}</div>
				<div>Task Id</div>
				<div className={s.generalTitle}>{basic.taskId}</div>
				<div>User Id</div>
				<div className={s.generalTitle}>{basic.userId}</div>
			</div>
			
			<div style={{display:"flex"}}>
				<MyTextarea title={'Student Submission'} value={basic.resultJson} />
				<MyTextarea title={'Final Return'} value={basic.aiJson} />
			</div>
		</div>
		{
			aiHistory.map((d, indexD) => (<div>
			
				{(d.type == "refinement") && (<div>
				<div style={{
            height: '10px',
            width: '100%',
            backgroundColor: '#565853', // You can change the color as needed
            margin: '10px 0' // Optional: Adds some space above and below the line
        }}></div>
				<div>start of processing Question {d.qtnIdx}</div>
				<div style={{
            height: '10px',
            width: '100%',
            backgroundColor: '#565853', // You can change the color as needed
            margin: '10px 0' // Optional: Adds some space above and below the line
        }}></div>
        </div>)}
			
			
			<div className={s.subPartHolder + ' ' + ((indexD % 2 == 0) ? "" : s.odd)} key={indexD + "userListenings"} >
				<div style={{display:"flex", gap:"10px", margin:"10px", alignItems:"center"}}>		
					<div >Type:</div>
					<div className={s.generalTitle + ' ' + ((indexD % 2 == 0) ? "" : s.odd)}>{d.type}</div>			
					<div>AI ID:</div>
					<div>{d.id}</div>
					<div>Qtn Idx:</div>
					<div>{d.qtnIdx}</div>
					<div>AI:</div>
					<div className={s.generalTitle + ' ' + ((indexD % 2 == 0) ? "" : s.odd)}>{d.aiType}</div>
				</div>
				
				
				<div style={{display:"flex"}}>
					{(d.type != "Final Output") && (<MyTextarea title={'Request'} value={d.request} /> )}
					<MyTextarea title={'Response'} value={d.feedback} /> 
				</div>
				</div>
				{(d.type == "Final Output") && (<div>
				<div style={{
            height: '10px',
            width: '100%',
            backgroundColor: '#565853', // You can change the color as needed
            margin: '10px 0' // Optional: Adds some space above and below the line
        }}></div>
				<div>end of processing</div>
				<div style={{
            height: '10px',
            width: '100%',
            backgroundColor: '#565853', // You can change the color as needed
            margin: '10px 0' // Optional: Adds some space above and below the line
        }}></div>
        </div>)}
			</div>))
		}
		
	</div>);
}

